import * as yup from "yup";

export const addCitySchema = yup.object().shape({
    name: yup
        .string()
        .min(3, "اسم المدينة يجب ان يكون اكبر من 3 حروف")
        .required("ادخل اسم المدينة المراد انشاؤه"),
});
